<template>
  <aside class="sidebar flex flex-col">
    <!-- 로고 영역 -->
    <div class="p-5 border-b border-slate-100 flex-shrink-0">
      <router-link to="/admin" class="flex items-center gap-2">
        <span class="text-[17px] font-black text-slate-800">물어다줄개</span>
        <span class="px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-gradient-to-r from-blue-600 to-indigo-600">ADMIN</span>
        <span class="text-[11px] text-slate-400">center</span>
      </router-link>
    </div>

    <!-- 프로필 영역 -->
    <div class="p-4 border-b border-slate-100 flex-shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center flex-shrink-0">
          <span class="text-white font-semibold text-sm">{{ userInitial }}</span>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-[14px] font-semibold text-slate-800 truncate">{{ userProfile?.name || '관리자' }}</p>
          <p class="text-[12px] text-slate-400 truncate">{{ userProfile?.email || '' }}</p>
        </div>
      </div>
    </div>

    <!-- 네비게이션 메뉴 -->
    <nav ref="navRef" class="flex-1 overflow-y-auto p-4 scrollbar-thin">
      <!-- 대시보드 -->
      <router-link
        to="/admin"
        class="flex items-center gap-3 px-4 py-3 rounded-xl mb-2 transition-all"
        :class="$route.path === '/admin' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
        </svg>
        <span class="text-[15px] font-bold">대시보드</span>
      </router-link>

      <!-- 현장 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('property')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isPropertyActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
            </svg>
            <span class="text-[15px] font-bold">현장 관리</span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.property ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.property" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/properties"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/properties' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            현장 목록
          </router-link>
          <router-link
            to="/admin/properties/create"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/properties/create' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            현장 등록
          </router-link>
        </div>
      </div>

      <!-- 파트너 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('partner')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isPartnerActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
            <span class="text-[15px] font-bold">파트너 관리</span>
            <span v-if="totalPartnerPending > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">
              {{ totalPartnerPending }}
            </span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.partner ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.partner" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/partner-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>소속 신청</span>
            <span v-if="pendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ pendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/point-charges"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/point-charges' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>포인트 충전</span>
            <span v-if="pointChargePendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ pointChargePendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/point-give"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/point-give' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            포인트 직접 지급
          </router-link>
          <router-link
            to="/admin/partner-notices"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-notices' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            파트너 공지사항
          </router-link>
          <router-link
            to="/admin/partner-updates"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-updates' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            파트너 업데이트
          </router-link>
          <router-link
            to="/admin/partner-dashboard-banners"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-dashboard-banners' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            대시보드 배너
          </router-link>
          <router-link
            to="/admin/partner-square-banners"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-square-banners' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            대시보드 사이드 배너
          </router-link>
          <router-link
            to="/admin/partner-feedbacks"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/partner-feedbacks' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>건의/신고</span>
            <span v-if="feedbackPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ feedbackPendingCount }}</span>
          </router-link>
        </div>
      </div>

      <!-- 광고 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('ad')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isAdActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"/>
            </svg>
            <span class="text-[15px] font-bold">광고 관리</span>
            <span v-if="totalAdPending > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">
              {{ totalAdPending }}
            </span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.ad ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.ad" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/adbanner-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/adbanner-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>인앱 광고</span>
            <span v-if="adBannerPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ adBannerPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/popup-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/popup-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>팝업 광고</span>
            <span v-if="popupPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ popupPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/splash-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/splash-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>스플래시 광고</span>
            <span v-if="splashPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ splashPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/recommend-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/recommend-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>추천 광고</span>
            <span v-if="recommendPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ recommendPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/listad-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/listad-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>리스트 광고</span>
            <span v-if="listAdPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ listAdPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/communityad-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/communityad-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>커뮤니티 광고</span>
            <span v-if="communityAdPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ communityAdPendingCount }}</span>
          </router-link>
          <router-link
            to="/admin/chatad-applications"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/chatad-applications' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>꾸우챗 광고</span>
            <span v-if="chatAdPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ chatAdPendingCount }}</span>
          </router-link>
        </div>
      </div>

      <!-- 홈 화면 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('home')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isHomeActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <span class="text-[15px] font-bold">홈 화면</span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.home ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.home" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/banners"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/banners' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            메인 배너
          </router-link>
          <router-link
            to="/admin/hot-ad"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/hot-ad' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            HOT 분양 AD
          </router-link>
          <router-link
            to="/admin/magazines"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/magazines' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            매거진 관리
          </router-link>
        </div>
      </div>

      <div class="h-px bg-slate-100 my-4"></div>

      <!-- 서비스 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('service')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isServiceActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <span class="text-[15px] font-bold">서비스 관리</span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.service ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.service" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/notices"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/notices' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            공지사항
          </router-link>
          <router-link
            to="/admin/events"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/events' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            이벤트
          </router-link>
          <router-link
            to="/admin/points/settings"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/points/settings' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            포인트 설정
          </router-link>
          <router-link
            to="/admin/points/products"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/points/products' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            상품 관리
          </router-link>
          <router-link
            to="/admin/points/orders"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/points/orders' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            주문 관리
          </router-link>
        </div>
      </div>

      <!-- 고객센터 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('support')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isSupportActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span class="text-[15px] font-bold">고객센터</span>
            <span v-if="inquiryPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">
              {{ inquiryPendingCount }}
            </span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.support ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.support" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/faq"
            class="block px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/faq' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            FAQ 관리
          </router-link>
          <router-link
            to="/admin/inquiries"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/inquiries' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>1:1 문의</span>
            <span v-if="inquiryPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ inquiryPendingCount }}</span>
          </router-link>
        </div>
      </div>

      <!-- 커뮤니티 관리 -->
      <div class="mb-2">
        <button
          @click.stop="toggleSection('community')"
          class="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all"
          :class="isCommunityActive ? 'bg-slate-100 text-blue-600' : 'text-slate-600 hover:bg-slate-50'"
        >
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"/>
            </svg>
            <span class="text-[15px] font-bold">커뮤니티</span>
            <span v-if="totalCommunityPending > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">
              {{ totalCommunityPending }}
            </span>
          </div>
          <svg
            class="w-4 h-4 transition-transform duration-200"
            :class="openSections.community ? 'rotate-180' : ''"
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        <div v-show="openSections.community" class="mt-2 ml-4 pl-4 border-l-2 border-slate-200 space-y-1">
          <router-link
            to="/admin/community-reports"
            class="flex items-center justify-between px-4 py-2.5 rounded-lg text-[14px] font-medium transition-all"
            :class="$route.path === '/admin/community-reports' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
          >
            <span>신고 관리</span>
            <span v-if="communityReportPendingCount > 0" class="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full">{{ communityReportPendingCount }}</span>
          </router-link>
        </div>
      </div>

      <!-- 사용자 관리 -->
      <div class="mb-2">
        <router-link
          to="/admin/users"
          class="flex items-center gap-3 px-4 py-3 rounded-xl transition-all"
          :class="$route.path === '/admin/users' ? 'bg-blue-600 text-white' : 'text-slate-600 hover:bg-slate-50'"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
          <span class="text-[15px] font-bold">사용자 목록</span>
        </router-link>
      </div>
    </nav>

    <!-- 하단 로그아웃 버튼 -->
    <div class="p-4 border-t border-slate-100 flex-shrink-0">
      <button
        @click="handleLogout"
        class="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-xl transition-colors"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
        </svg>
        <span class="text-[14px] font-medium">로그아웃</span>
      </button>
    </div>
  </aside>
</template>

<script>
import { ref, computed, reactive, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { db } from '@/firebase/firebase'
import { useAuth } from '@/composables/common/useAuth'

// 전역 사이드바 스크롤 위치 저장
let savedNavScrollTop = 0

export default {
  name: 'AdminSideBar',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { userProfile, logout } = useAuth()
    const navRef = ref(null)

    // 대기중 카운트
    const pendingCount = ref(0)
    const adBannerPendingCount = ref(0)
    const popupPendingCount = ref(0)
    const splashPendingCount = ref(0)
    const recommendPendingCount = ref(0)
    const listAdPendingCount = ref(0)
    const inquiryPendingCount = ref(0)
    const pointChargePendingCount = ref(0)
    const communityReportPendingCount = ref(0)
    const communityAdPendingCount = ref(0)
    const chatAdPendingCount = ref(0)
    const feedbackPendingCount = ref(0)

    // 섹션 열림 상태
    const openSections = reactive({
      property: false,
      partner: false,
      ad: false,
      home: false,
      service: false,
      support: false,
      community: false
    })

    // 섹션 토글
    const toggleSection = (section) => {
      openSections[section] = !openSections[section]
    }

    // 총 대기 카운트 계산
    const totalPartnerPending = computed(() => pendingCount.value + pointChargePendingCount.value + feedbackPendingCount.value)
    const totalAdPending = computed(() =>
      adBannerPendingCount.value + popupPendingCount.value + splashPendingCount.value +
      recommendPendingCount.value + listAdPendingCount.value + communityAdPendingCount.value +
      chatAdPendingCount.value
    )
    const totalCommunityPending = computed(() => communityReportPendingCount.value)

    // 활성 상태 체크
    const isPropertyActive = computed(() => route.path.startsWith('/admin/properties'))
    const isPartnerActive = computed(() =>
      route.path === '/admin/partner-applications' ||
      route.path === '/admin/point-charges' ||
      route.path === '/admin/point-give' ||
      route.path === '/admin/partner-notices' ||
      route.path === '/admin/partner-updates' ||
      route.path === '/admin/partner-dashboard-banners' ||
      route.path === '/admin/partner-square-banners' ||
      route.path === '/admin/partner-feedbacks'
    )
    const isAdActive = computed(() =>
      route.path === '/admin/adbanner-applications' ||
      route.path === '/admin/popup-applications' ||
      route.path === '/admin/splash-applications' ||
      route.path === '/admin/recommend-applications' ||
      route.path === '/admin/listad-applications' ||
      route.path === '/admin/communityad-applications' ||
      route.path === '/admin/chatad-applications'
    )
    const isHomeActive = computed(() =>
      route.path === '/admin/banners' ||
      route.path === '/admin/hot-ad' ||
      route.path === '/admin/magazines'
    )
    const isServiceActive = computed(() =>
      route.path === '/admin/notices' ||
      route.path === '/admin/events' ||
      route.path.startsWith('/admin/points')
    )
    const isSupportActive = computed(() =>
      route.path === '/admin/faq' ||
      route.path === '/admin/inquiries'
    )
    const isCommunityActive = computed(() =>
      route.path === '/admin/community-reports'
    )

    const userInitial = computed(() => {
      const name = userProfile.value?.name || userProfile.value?.email || ''
      return name.charAt(0).toUpperCase()
    })

    // 사이드바 스크롤 위치 저장
    const saveNavScroll = () => {
      if (navRef.value) {
        savedNavScrollTop = navRef.value.scrollTop
      }
    }

    // 사이드바 스크롤 위치 복원
    const restoreNavScroll = () => {
      if (navRef.value && savedNavScrollTop > 0) {
        navRef.value.scrollTop = savedNavScrollTop
      }
    }

    const handleLogout = async () => {
      await logout()
      router.push('/login')
    }

    // 대기중인 신청 수 실시간 감시
    onMounted(() => {
      // 현재 경로에 맞는 섹션 열기
      if (isPropertyActive.value) openSections.property = true
      if (isPartnerActive.value) openSections.partner = true
      if (isAdActive.value) openSections.ad = true
      if (isHomeActive.value) openSections.home = true
      if (isServiceActive.value) openSections.service = true
      if (isSupportActive.value) openSections.support = true
      if (isCommunityActive.value) openSections.community = true

      // 스크롤 위치 복원
      setTimeout(() => {
        restoreNavScroll()
      }, 0)

      // 스크롤 이벤트로 위치 저장
      if (navRef.value) {
        navRef.value.addEventListener('scroll', saveNavScroll)
      }

      // 파트너 소속 신청
      const partnerQ = query(
        collection(db, 'partnerApplications'),
        where('status', '==', 'pending')
      )
      onSnapshot(partnerQ, (snapshot) => {
        pendingCount.value = snapshot.size
      })

      // 인앱 광고 신청
      const adBannerQ = query(
        collection(db, 'adBanners'),
        where('status', '==', 'pending')
      )
      onSnapshot(adBannerQ, (snapshot) => {
        adBannerPendingCount.value = snapshot.size
      })

      // 팝업 광고 신청
      const popupQ = query(
        collection(db, 'popupAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(popupQ, (snapshot) => {
        popupPendingCount.value = snapshot.size
      })

      // 스플래시 광고 신청
      const splashQ = query(
        collection(db, 'splashAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(splashQ, (snapshot) => {
        splashPendingCount.value = snapshot.size
      })

      // 추천 광고 신청
      const recommendQ = query(
        collection(db, 'recommendAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(recommendQ, (snapshot) => {
        recommendPendingCount.value = snapshot.size
      })

      // 리스트 광고 신청
      const listAdQ = query(
        collection(db, 'listAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(listAdQ, (snapshot) => {
        listAdPendingCount.value = snapshot.size
      })

      // 1:1 문의
      const inquiryQ = query(
        collection(db, 'inquiries'),
        where('status', '==', 'pending')
      )
      onSnapshot(inquiryQ, (snapshot) => {
        inquiryPendingCount.value = snapshot.size
      })

      // 포인트 충전 신청
      const pointChargeQ = query(
        collection(db, 'pointChargeRequests'),
        where('status', '==', 'pending')
      )
      onSnapshot(pointChargeQ, (snapshot) => {
        pointChargePendingCount.value = snapshot.size
      })

      // 커뮤니티 신고
      const communityReportQ = query(
        collection(db, 'communityReports'),
        where('status', '==', 'pending')
      )
      onSnapshot(communityReportQ, (snapshot) => {
        communityReportPendingCount.value = snapshot.size
      })

      // 커뮤니티 광고 신청
      const communityAdQ = query(
        collection(db, 'communityAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(communityAdQ, (snapshot) => {
        communityAdPendingCount.value = snapshot.size
      })

      // 꾸우챗 광고 신청
      const chatAdQ = query(
        collection(db, 'chatAds'),
        where('status', '==', 'pending')
      )
      onSnapshot(chatAdQ, (snapshot) => {
        chatAdPendingCount.value = snapshot.size
      })

      // 파트너 건의/신고
      const feedbackQ = query(
        collection(db, 'partnerFeedbacks'),
        where('status', '==', 'pending')
      )
      onSnapshot(feedbackQ, (snapshot) => {
        feedbackPendingCount.value = snapshot.size
      })
    })

    onBeforeUnmount(() => {
      if (navRef.value) {
        navRef.value.removeEventListener('scroll', saveNavScroll)
      }
    })

    return {
      navRef,
      userProfile,
      userInitial,
      openSections,
      toggleSection,
      pendingCount,
      adBannerPendingCount,
      popupPendingCount,
      splashPendingCount,
      recommendPendingCount,
      listAdPendingCount,
      inquiryPendingCount,
      pointChargePendingCount,
      communityReportPendingCount,
      communityAdPendingCount,
      chatAdPendingCount,
      feedbackPendingCount,
      totalPartnerPending,
      totalAdPending,
      totalCommunityPending,
      isPropertyActive,
      isPartnerActive,
      isAdActive,
      isHomeActive,
      isServiceActive,
      isSupportActive,
      isCommunityActive,
      handleLogout
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 256px;
  min-width: 256px;
  max-width: 256px;
  height: 100%;
  background-color: white;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 2px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}
</style>
